import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { Box } from '@mui/material';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { GSMIconWithInfo } from 'console/shared/components/indicators/gsm/with-info';
import { WiFiIconWithInfo } from 'console/shared/components/indicators/wifi/with-info';
import { EthernetIconWithInfo } from 'console/shared/components/indicators/ethernet/with-info';
import { getConnectionConfig } from 'console/shared/components/indicators/connection-icons/selector';
export const ConnectionIconsWithInfo = memo(function ConnectionIconsWithInfo(props) {
    const { device_id, ...rest } = props;
    const connection_config = usePartialAppSelector(getConnectionConfig, device_id);
    if (!connection_config) {
        return null;
    }
    return (_jsxs(Box, { display: "flex", alignItems: "center", columnGap: 0.5, justifySelf: "flex-end", children: [connection_config.has_gsm && (_jsx(GSMIconWithInfo, { device_id: device_id, ...rest })), (connection_config.has_wifi || connection_config.has_legacy_wifi) && (_jsx(WiFiIconWithInfo, { device_id: device_id, ...rest })), connection_config.has_ethernet && (_jsx(EthernetIconWithInfo, { device_id: device_id, ...rest }))] }));
});
